<div class="personal-information-main-container">
  <section class="top-section">
    <cp-logo></cp-logo>
  </section>
  <section class="back-home-section">
    <go-back (click)="back()"></go-back>
  </section>

  <div class="flow-container">
    <div class="">
      <section class="new-password-container" [formGroup]="form">
        <h1>Personal Information</h1>
        <label for="">Name</label>
        <gbui-input
          formControlName="firstName"
          simple
          placeholder="Enter your name here"
        ></gbui-input>
        <label for="">Last name</label>
        <gbui-input
          formControlName="lastName"
          simple
          placeholder="Enter your last name here"
        ></gbui-input>
        <label for="">Job tile </label>
        <gbui-input
          formControlName="jobTitle"
          simple
          placeholder="Enter your job title"
        ></gbui-input>
        <!-- <div class="simulate-input">{{ form.get("jobTitle")?.value }}</div> -->
        <label for="">Department</label>
        <gbui-input
          formControlName="department"
          simple
          placeholder="Enter the department"
        ></gbui-input>
        <!-- <div class="simulate-input">{{ form.get("department")?.value }}</div> -->
        <gbui-button
          (click)="setPersonalInformation()"
          [disabled]="form.invalid"
          class="buttons-outline"
          type="submit"
          >Save</gbui-button
        >
      </section>
    </div>
  </div>
</div>
